<template>
  <div>
    <b-row>
      <b-col offset-md="11" md="1">
        <help>
          <template v-slot:title>References help</template>
          <p>
            This view lists all database hits with their description. When you
            click on the name of the entry it will be openend in its source
            database.
          </p>
        </help>
      </b-col>
    </b-row>
    <ReferencesTable :dbxrefs="content.dbxrefs"></ReferencesTable>
  </div>
</template>
<script>
import ReferencesTable from "@/components/ReferencesTable.vue";
import ResultMixin from "@/mixins/job-result.vue";
import Layout from "@/mixins/psov-layout.vue";
import Help from "@/components/Help.vue";

export default {
  data: function() {
    return {};
  },
  mixins: [ResultMixin, Layout],
  components: { ReferencesTable, Help },
  computed: {}
};
</script>
<style scoped></style>
